<script>
    let active = false;
    const start = () => (active = true);
    const end = () => (active = false);
</script>

<button
    type="button"
    class:active
    class={$$props.class}
    on:touchstart={start}
    on:touchend={end}
    on:click><slot /></button
>

<style lang="less">
    @import "./keybutton.less";
</style>
